export default "__VITE_ASSET__a7b01aa8__"